// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Regex from "../utils/Regex.bs.js";
import * as $$String from "@rescript/std/lib/es6/string.js";
import * as Js_string from "@rescript/std/lib/es6/js_string.js";
import * as LibPhoneNumber from "../bindings/LibPhoneNumber.bs.js";

function validateEmail(email) {
  if (email === "") {
    return {
            TAG: /* Error */1,
            _0: "Your email is required"
          };
  } else if (Regex.emailRegex.test(email)) {
    return {
            TAG: /* Ok */0,
            _0: email
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: "Please enter a valid email address"
          };
  }
}

function validateLoginPassword(password) {
  if (password === "") {
    return {
            TAG: /* Error */1,
            _0: "Password is required"
          };
  } else {
    return {
            TAG: /* Ok */0,
            _0: password
          };
  }
}

function validatePassword(password) {
  var passwordRegex = /^((?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,100})$/;
  if (password === "") {
    return {
            TAG: /* Error */1,
            _0: "Password is required"
          };
  } else if (passwordRegex.test(password)) {
    return {
            TAG: /* Ok */0,
            _0: password
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: "Please retry with a more secure password. (Max: 100 Characters)"
          };
  }
}

function getCleanPhoneNumber(dirtyNumber) {
  return Js_string.replaceByRe(/\D+/g, "", dirtyNumber);
}

function optionalPhoneNumber(phoneNumber) {
  var phoneNumberRegex = /^([0-9]{5,13})$/;
  var cleanNumber = getCleanPhoneNumber(phoneNumber);
  if (phoneNumberRegex.test(cleanNumber)) {
    return {
            TAG: /* Ok */0,
            _0: "+" + cleanNumber
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: "Invalid phone number"
          };
  }
}

function validatePhoneNumber(phoneNumber) {
  var phoneNumberRegex = /^([0-9]{5,13})$/;
  var cleanNumber = getCleanPhoneNumber(phoneNumber);
  if (cleanNumber === "") {
    return {
            TAG: /* Error */1,
            _0: "Phone number is required"
          };
  } else if (phoneNumberRegex.test(cleanNumber)) {
    return {
            TAG: /* Ok */0,
            _0: "+" + cleanNumber
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: "Invalid phone number"
          };
  }
}

function validatePhone(countryCode, phone) {
  var validNumber = LibPhoneNumber.isValidPhoneNumber($$String.uppercase_ascii(countryCode), phone);
  var val;
  try {
    val = validNumber;
  }
  catch (exn){
    if (phone === "") {
      return {
              TAG: /* Ok */0,
              _0: ""
            };
    }
    throw exn;
  }
  if (val) {
    return {
            TAG: /* Ok */0,
            _0: "+" + phone
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: "Please enter a valid mobile number"
          };
  }
}

export {
  validateEmail ,
  validateLoginPassword ,
  validatePassword ,
  getCleanPhoneNumber ,
  optionalPhoneNumber ,
  validatePhoneNumber ,
  validatePhone ,
}
/* LibPhoneNumber Not a pure module */
